import React from 'react';
import { NavigateFunction } from 'react-router-dom';

import { Bulletin, Editor, EditorTools, Header, Screen } from './components';
import AgentEntry from './components/AgentEntry/index';
import { AdvisoryType } from './components/plugins';
import { getConfig } from './config';
import { UpchatClient, UpchatMessage } from './upchat-sdk';
import * as forage from './upchat-sdk/forage';
import { MIME, Mode } from './upchat-sdk/message';
import * as notify from './utils/notify';

interface IComponentProps {
  navigate: NavigateFunction;
}
interface IComponentState {
  code: string;
  client: UpchatClient;
  messages: UpchatMessage[];
  openEmojiPicker: boolean;
  openFeedbackForm: boolean;
  openOpinionForm: boolean;
  openUserInfoForm: boolean;
  openProblemForm: boolean;
  hasOpinionExists: boolean;
  hasAdvisoryTypeExists: boolean;
}

export default class App extends React.Component<
  IComponentProps,
  IComponentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      code: '',
      messages: [],

      openEmojiPicker: false,
      openFeedbackForm: false,
      openOpinionForm: false,
      openUserInfoForm: false,
      openProblemForm: false,
      hasOpinionExists: false,
      hasAdvisoryTypeExists: false,

      client: new UpchatClient({
        websocketURL: getConfig().websocketURL,
        serviceURl: getConfig().serviceURL,
        navigate: this.props.navigate,
      }),
    };
  }

  private emojiRef: React.RefObject<EditorTools> =
    React.createRef<EditorTools>();

  componentDidMount() {
    this.state.client.connect();
    document.addEventListener('click', this.handleDocumentClick);

    // @ts-ignore
    forage.getHistoryMessages().then((res: UpchatMessage[]) => {
      if (!res) return;
      this.state.messages.unshift(...res);
      this.forceUpdate();
    });

    this.state.client.onMessage((type, message) => {
      this.state.messages.push(message);
      if (type === 'direct') notify.soundNoisy();
      if (message.data.mode === Mode.O_NORMAL) {
        forage.appendHistoryMessages(message);
      }
      this.forceUpdate();
    });

    this.state.client.onMessageDel((messageId) => {
      this.state.messages.forEach((v) => {
        if (v.data.message_id === messageId) {
          v.data.deleted_at = new Date().toISOString();
          console.log(v);
        }
      });
      forage.removeHistoryMessage(messageId);
      this.forceUpdate();
    });
    this.state.client.subscribe(() => this.forceUpdate());

    // 补偿相关逻辑
    this.getReparationReward();
  }

  /** 添加客服页面到桌面，领取奖励 */
  getReparationReward = async () => {
    try {
      // 从url里获取query参数
      const apihost = process.env.REACT_APP_YUPOO_API_HOST;
      const urlParams = new URLSearchParams(window.location.search);
      const isFromScreen = urlParams.get('from') === 'screen';
      const username = urlParams.get('name');
      const userId = urlParams.get('id');
      if (!isFromScreen || !username || !userId) return;
      const key = `reparation:addCustomer@${username}`;
      const reparation = localStorage.getItem(key);
      if (reparation === '1') return;
      // '0' 初次打开 '1' 可领取
      if (!reparation) {
        return localStorage.setItem(key, '0');
      }
      if (reparation === '0') {
        // 完成任务
        await fetch(`${apihost}/task/finish`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: userId,
            type: 'addCustomer',
          }),
        });
        localStorage.setItem(key, '1');
      }
    } catch (error) {
      console.log('getReparationReward error:', error);
    }
  };
  componentWillUnmount() {
    this.state.client.io?.close();
    document.removeEventListener('click', this.handleDocumentClick);
  }

  handleDocumentClick = () => this.setState({ openEmojiPicker: false });

  render() {
    return (
      <div id="root" className="h-screen flex flex-col justify-between">
        <Header
          logo={getConfig().header.logo}
          style={{ height: '7%', minHeight: '60px' }}
          serviceName={getConfig().header.content}
          schedule={this.state.client.connectStatus}
        />

        <div className="flex divide-x" style={{ height: '93%' }}>
          <div className="flex-1 flex-1 flex flex-col bg-gray-50">
            <Screen
              className="flex-1 scrolling-auto overflow-y-scroll py-2"
              messages={this.state.messages.concat()}
              handleSubmitOpinion={(data) => {
                this.state.client.syscallSubmitOpinion(data);
                this.setState({
                  messages: this.state.messages.filter(
                    (v) => v.data.mode !== Mode.O_PLUGINS_INVITE
                  ),
                });
              }}
              handleSubmitUserInfo={(data) => {
                this.state.client.syscallSubmitUserInfo(data);
                this.setState({
                  messages: this.state.messages.filter(
                    (v) => v.data.mode !== Mode.O_PLUGINS_USERINFO
                  ),
                });
              }}
              handleSubmitFeedback={(data) => {
                this.state.client.syscallSubmitFeedback(data);
                this.setState({
                  messages: this.state.messages.filter(
                    (v) => v.data.mode !== Mode.O_PLUGINS_FEEDBACK
                  ),
                });
              }}
              handleSubmitOfflineMsg={async (data) => {
                const result = await this.state.client.syscallSubmitOfflineMsg(
                  data
                );
                if (!result) {
                  return;
                }
                this.setState({
                  messages: this.state.messages.filter(
                    (v) => v.data.mode !== Mode.O_PLUGINS_OFFLINEMSG
                  ),
                });
                alert('提交成功！');
              }}
              handleSubmitAdvisoryType={(data) => {
                if (this.state.hasAdvisoryTypeExists) {
                  return;
                }

                this.setState({ hasAdvisoryTypeExists: true });
                this.state.client.syscallSubmitAdvisoryType(data);

                if (data === AdvisoryType.解冻处理) {
                  setTimeout(
                    () => this.setState({ openUserInfoForm: true }),
                    1000
                  );
                }
                if (data === AdvisoryType.反馈建议) {
                  setTimeout(
                    () => this.setState({ openFeedbackForm: true }),
                    1000
                  );
                }
                if (data === AdvisoryType.其他问题) {
                  setTimeout(
                    () => this.setState({ openProblemForm: true }),
                    1000
                  );
                }
              }}
            />

            <div>
              <EditorTools
                ref={this.emojiRef}
                openEmojiPicker={this.state.openEmojiPicker}
                toggleOpenEmojiPicker={(e: any) => {
                  e.nativeEvent.stopImmediatePropagation();
                  this.setState({
                    openEmojiPicker: !this.state.openEmojiPicker,
                  });
                }}
                openFeedbackForm={this.state.openFeedbackForm}
                toggleOpenFeedbackForm={() =>
                  this.setState({
                    openFeedbackForm: !this.state.openFeedbackForm,
                  })
                }
                openOpinionForm={this.state.openOpinionForm}
                toggleOpenOpinionForm={() =>
                  this.setState({
                    openOpinionForm: !this.state.openOpinionForm,
                  })
                }
                openUserInfoForm={this.state.openUserInfoForm}
                toggleOpenUserInfoForm={() =>
                  this.setState({
                    openUserInfoForm: !this.state.openUserInfoForm,
                  })
                }
                handleSubmitFile={this.state.client.sendFile}
                handlePick={(s) =>
                  this.setState({
                    code: this.state.code + s,
                    openEmojiPicker: false,
                  })
                }
                openProblemForm={this.state.openProblemForm}
                toggleOpenProblemForm={() =>
                  this.setState({
                    openProblemForm: !this.state.openProblemForm,
                  })
                }
                handleSubmitProblem={(data) => {
                  this.state.client.syscallSubmitProblem(data);
                  this.setState({ openProblemForm: false });
                }}
                handleSubmitOpinion={(data) => {
                  if (this.state.hasOpinionExists) {
                    return alert('您已经评价过了');
                  }
                  this.state.client.syscallSubmitOpinion(data);
                  this.setState({
                    hasOpinionExists: true,
                    openOpinionForm: false,
                  });
                }}
                handleSubmitUserInfo={(data) => {
                  this.state.client.syscallSubmitUserInfo(data);
                  this.setState({ openUserInfoForm: false });
                }}
                handleSubmitFeedback={(data) => {
                  this.state.client.syscallSubmitFeedback(data);
                  this.setState({ openFeedbackForm: false });
                }}
              />

              <Editor
                code={this.state.code}
                handleSubmitFile={this.state.client.sendFile}
                handleChange={(code) => this.setState({ code })}
                handleSubmit={(code) =>
                  this.state.client.send({
                    content_type: MIME['text/plain'],
                    content: code,
                  })
                }
              />
            </div>
          </div>
          <div className="bg-white w-60 border-l hidden lg:block xl:block relative">
            <Bulletin
              content={getConfig().bulletin.content}
              helper={getConfig().bulletin.helper}
              worktime={getConfig().bulletin.worktime}
            />
            <AgentEntry></AgentEntry>
          </div>
        </div>
      </div>
    );
  }
}
